// src/pages/Invoices/InvoiceTypesPage.jsx

import React, { useState, useEffect } from 'react'
import axios from '../../axios'
import { Card, CardContent } from '../../components/ui/card'
import { Input } from '../../components/ui/input'
import { Button } from '../../components/ui/button'

export default function InvoiceTypesPage() {
  const companyId = parseInt(localStorage.getItem('companyId'), 10)

  const [types, setTypes] = useState([])
  const [form, setForm]   = useState({
    companyId,
    name: '',
    direction: 1        // 1 = Inbound (إدخال) ، 2 = Outbound (إخراج)
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!companyId) return
    fetchTypes()
  }, [companyId])

  const fetchTypes = async () => {
    try {
      const res = await axios.get(`/InvoiceTypes?companyId=${companyId}`)
      setTypes(res.data)
    } catch (err) {
      console.error('❌ خطأ تحميل أنواع الفواتير:', err)
    }
  }

  const handleChange = e => {
    const { name, value } = e.target
    setForm(f => ({
      ...f,
      [name]: name === 'direction' ? Number(value) : value
    }))
  }

  const handleAdd = async () => {
  if (!form.name.trim()) {
    return alert('❌ الرجاء إدخال اسم النوع.')
  }

  setLoading(true)
  try {
    await axios.post(
      `/InvoiceTypes?companyId=${companyId}`,
      {
        name: form.name,
        direction: form.direction
      }
    )

    setForm({ companyId, name: '', direction: 1 })
    fetchTypes()
  } catch (err) {
    console.error('❌ خطأ إضافة نوع فاتورة:', err.response?.data || err)
    alert(err.response?.data || '❌ حدث خطأ أثناء الإضافة.')
  } finally {
    setLoading(false)
  }
}


  const handleDelete = async id => {
    if (!window.confirm('❗ تأكيد حذف النوع؟')) return
    try {
      await axios.delete(`/InvoiceTypes/${id}`)
      fetchTypes()
    } catch (err) {
      console.error('❌ خطأ عند الحذف:', err)
      alert('❌ حدث خطأ أثناء الحذف.')
    }
  }

  // مساعدة لعرض التسمية العربية بناءً على القيمة
  const directionLabel = dir => dir === 1 ? 'إدخال' : 'إخراج'

  return (
    <Card className="max-w-4xl mx-auto mt-10 p-6 shadow-lg" dir="rtl">
      <CardContent>
        <h2 className="text-xl font-bold mb-4">📑 إدارة أنواع الفواتير</h2>

        {/* نموذج الإضافة */}
        <div className="grid grid-cols-4 gap-4 mb-6">
          <Input
            name="name"
            placeholder="اسم النوع"
            value={form.name}
            onChange={handleChange}
          />
          <select
            name="direction"
            value={form.direction}
            onChange={handleChange}
            className="border rounded px-2 py-1"
          >
            <option value={1}>إدخال</option>
            <option value={2}>إخراج</option>
          </select>
          <div /> {/* فراغ للتنسيق */}
          <Button onClick={handleAdd} disabled={loading}>
            {loading ? 'جاري الإضافة...' : '➕ إضافة'}
          </Button>
        </div>

        {/* جدول الأنواع */}
        <div className="overflow-x-auto">
          <table className="w-full table-auto border-collapse text-sm">
            <thead>
              <tr className="bg-gray-100 text-center">
                <th className="px-4 py-2 border">#</th>
                <th className="px-4 py-2 border">الاسم</th>
                <th className="px-4 py-2 border">الاتجاه</th>
                <th className="px-4 py-2 border">إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {types.map((t, idx) => (
                <tr key={t.id} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-4 py-2 border text-center">{idx + 1}</td>
                  <td className="px-4 py-2 border">{t.name}</td>
                  <td className="px-4 py-2 border text-center">
                    {directionLabel(t.direction)}
                  </td>
                  <td className="px-4 py-2 border text-center">
                    <Button
                      size="sm"
                      variant="destructive"
                      onClick={() => handleDelete(t.id)}
                    >
                      🗑️
                    </Button>
                  </td>
                </tr>
              ))}
              {types.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-4 py-6 border text-center text-gray-500">
                    لا يوجد أنواع
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  )
}
